<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" v-model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="类别:" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.className" placeholder="请输入类别名称"></el-input>
					</el-form-item>
					<el-form-item>
							<el-button type="primary" @click="search">搜索</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="editialogVisible()">新增类别
							</el-button>	
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="storeClassinfo.list" style="width: 100%" row-key="id" :header-cell-style="headClass" border lazy
			v-loading="loading" element-loading-text="拼命加载中">
		
			<el-table-column prop="id" label="经营类别ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="className" label="类别名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="image" label="分类图片" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.image" :src="scope.row.image"
						@click="dialogImageUrl=scope.row.image;dialogVisibleImg=true;" width="64px" />
					<div v-else>暂无图标</div>
				</template>
			</el-table-column>
			<el-table-column prop="orderIndex" label="排序级别" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="isShow" label="是否显示" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isShow">是</p>
					<p v-else>否</p>
				</template>
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
		
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" 
					@click="bianji(scope.row.id,scope.row.className,scope.row.image,scope.row.orderIndex,scope.row.isShow)">编辑</el-button>
					<el-button size="small" type="text" @click="del(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		
		<el-dialog style="float:rigin" :title="dilogtitle" :visible.sync="addDialog" width="50%" :close-on-click-modal="false"
			:show-close="false">
			<div class="app-container">
				<el-form ref="form" :model="form"  size="medium">
					
					<el-form-item label="类别名称:">
						<el-input type="text" style="width: 260px;"  size="small"
							v-model="form.className" placeholder="请输入类别名称" />
					</el-form-item>
				
					<el-form-item label="分类图标:">
						<el-upload :action="httpUrl" list-type="picture-card" :limit='1' 
						:on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
							:on-success="onSuccess" >
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
		
					<el-form-item label="排序级别:">
						<el-input type="text" style="width: 260px;" oninput="value=value.replace(/[^0-9.]/g,'')" size="small"
							v-model="form.orderIndex" placeholder="请输入数字" />
					</el-form-item>
					<el-form-item label="是否显示:" class="redItem">
						<el-switch v-model="form.isShow" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>
					
					<el-form-item>
						<el-button v-if="this.dilogtitle=='新增店铺类别'" :loading="loading" type="primary" @click="add">添加</el-button>
						<el-button v-if="this.dilogtitle=='编辑店铺类别'" :loading="loading" type="primary" @click="edit">修改</el-button>
						<el-button v-if="this.dilogtitle=='新增店铺类别'" @click="addDialog = false">取 消</el-button>
						<el-button v-if="this.dilogtitle=='编辑店铺类别'" @click="quxiao">取 消</el-button>
						<!--editstoreClass <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('bniescategory');
	export default{
		data(){
			return{
				searchInfo:{},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				loading:false,
				storeClassinfo:{},
				addDialog:false,
				form: {
					className: "",
					isShow: "",
					image: "",
					orderIndex: '',
				},
				httpUrl: urls,
				goodsImages: {},
				fileList: [],
				dilogtitle:'',
				storeclassId:''
			}
		},
		methods:{
			search(){
				this.getClassList()
			},
			empty(){
				this.searchInfo = {}
			},
			editialogVisible(){
				this.dilogtitle = '新增店铺类别'
				this.addDialog = true
			},
			bianji(id){
				this.storeclassId = id
				this.dilogtitle = '编辑店铺类别'
				this.addDialog = true
				this.$api.editfindClass(id).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.form = res.data
						let imagesArray = res.data.image.split(",");
						this.goodsImages = imagesArray;
						for (let i = 0; i < imagesArray.length; i++) {
							this.fileList.push({
								name: imagesArray[i],
								message: imagesArray[i]
							})
						}
						console.log(this.fileList);
											
					}
				})
				
			},
			del(id){
				this.$api.delstClass(id).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			add(){
				if(!this.form.className){
					this.$message.warning('请填写经营类别名称');
					return
				}
				let data = {
					className:this.form.className,
					image:this.goodsImages.message,
					orderIndex:this.form.orderIndex,
					isShow:this.form.isShow,
				}
				this.$api.addstoreClass(data).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.addDialog = false
						this.storeClassList()
					}
				})
			},
			edit(){
				let data = {
					id:this.storeclassId,
					className:this.form.className,
					image:this.fileList[0].message,
					isShow:this.form.isShow,
					orderIndex:this.form.orderIndex
				}
				this.$api.editstoreClass(data).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.addDialog = false
						this.storeClassList()
					}
				})
			},
			quxiao(){
				this.addDialog = false
				this.fileList = []
			},
			onSuccess(response, file, fileList) {
				console.log(response)
				this.goodsImages=response;
			
				
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			storeClassList(){
				this.loading = true
				let data = {
					className:this.searchInfo.className
				}
				this.$api.findStclass(data).then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.storeClassinfo = res.data
						this.loading = false
					}
				})
			}
			
		},
		created() {
			this.storeClassList()
		}
	}
</script>

<style>
</style>